// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Recover Page Styles - Matches Figma HoF-26-Working Design */

.recover-page-wrapper {
  min-height: calc(100vh - 117px);
  background: #f4f4f4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.recover-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 117px);
  padding: 40px 20px;
  background: #f4f4f4;
}

.recover-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: 888px;
  margin: 0 auto;
}

.recover-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;
  width: 100%;
}

.recover-title {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 800;
  font-size: 48px;
  line-height: 1.1;
  color: #236cff;
  letter-spacing: -0.24px;
  margin: 0;
}

/* Success Page Styles */
.recover-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  text-align: center;
  width: 100%;
  max-width: 600px;
  padding: 40px 20px;
}

.recover-success-title {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 800;
  font-size: 48px;
  line-height: 1.1;
  color: #236cff;
  letter-spacing: -0.24px;
  margin: 0;
}

.recover-success-message {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.6;
  color: #00254a;
  margin: 0;
}

@media (max-width: 767px) {
  .recover-title {
    font-size: 36px;
  }
}

.recover-subtitle {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.6;
  color: #00254a;
  margin: 0;
}

.recover-form {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 440px;
}

.recover-field-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding-bottom: 30px;
}

.recover-label {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.5;
  color: #000000;
  margin: 0;
}

.recover-input {
  width: 100%;
  max-width: 400px;
  height: 60px;
  border-radius: 14px;
  border: 1px solid rgba(0, 37, 74, 0.3);
  padding: 0 16px;
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-size: 16px;
  background: white;
  color: #00254a;
  transition: all 0.2s ease;
}

.recover-input:focus {
  outline: 2px solid #1c60ea;
  outline-offset: -1px;
  border-color: #1c60ea;
}

.recover-input::placeholder {
  color: rgba(0, 37, 74, 0.5);
}

.recover-input:disabled {
  background: #f4f4f4;
  cursor: not-allowed;
}

.recover-field-container.has-error .recover-input {
  border-color: #e40001;
  background: linear-gradient(90deg, rgba(228, 0, 1, 0.05) 0%, rgba(228, 0, 1, 0.05) 100%), white;
}

.recover-error-message {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6;
  color: #e40001;
  margin: 4px 0 0 0;
}

.recover-turnstile {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 0 20px 0;
}

.recover-actions {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.recover-button-container {
  display: flex;
  gap: 16px;
  width: 100%;
  flex-direction: column;
}

@media (min-width: 480px) {
  .recover-button-container {
    flex-direction: row;
  }
}

.recover-back-button,
.recover-submit-button {
  flex: 1;
  min-height: 48px;
  padding: 10px 24px;
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.recover-back-button {
  background-color: transparent;
  color: #00254b;
  border: 2px solid #00254b;
}

.recover-back-button:hover:not(:disabled) {
  background-color: rgba(0, 37, 75, 0.05);
}

.recover-back-button:active:not(:disabled) {
  background-color: rgba(0, 37, 75, 0.1);
}

.recover-submit-button {
  background-color: #205ea3;
  color: white;
}

.recover-submit-button:hover:not(:disabled) {
  background-color: #174a85;
}

.recover-submit-button:active:not(:disabled) {
  background-color: #0f3661;
}

.recover-submit-button:disabled,
.recover-back-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.recover-register-link {
  font-family: 'AvenirNext forINTUIT', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.6;
  color: #205ea3;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
  text-align: center;
  display: block;
  width: 100%;
}

.recover-register-link:hover {
  color: #1c60ea;
  text-decoration: underline;
}

.recover-register-link:focus-visible {
  outline: 2px solid #1c60ea;
  outline-offset: 2px;
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/RecoverPage.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,+FAA+F;AACjG;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* Recover Page Styles - Matches Figma HoF-26-Working Design */\n\n.recover-page-wrapper {\n  min-height: calc(100vh - 117px);\n  background: #f4f4f4;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n}\n\n.recover-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 117px);\n  padding: 40px 20px;\n  background: #f4f4f4;\n}\n\n.recover-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  width: 100%;\n  max-width: 888px;\n  margin: 0 auto;\n}\n\n.recover-header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n}\n\n.recover-title {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 800;\n  font-size: 48px;\n  line-height: 1.1;\n  color: #236cff;\n  letter-spacing: -0.24px;\n  margin: 0;\n}\n\n/* Success Page Styles */\n.recover-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 32px;\n  text-align: center;\n  width: 100%;\n  max-width: 600px;\n  padding: 40px 20px;\n}\n\n.recover-success-title {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 800;\n  font-size: 48px;\n  line-height: 1.1;\n  color: #236cff;\n  letter-spacing: -0.24px;\n  margin: 0;\n}\n\n.recover-success-message {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #00254a;\n  margin: 0;\n}\n\n@media (max-width: 767px) {\n  .recover-title {\n    font-size: 36px;\n  }\n}\n\n.recover-subtitle {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.6;\n  color: #00254a;\n  margin: 0;\n}\n\n.recover-form {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  width: 100%;\n  max-width: 440px;\n}\n\n.recover-field-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  padding-bottom: 30px;\n}\n\n.recover-label {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 1.5;\n  color: #000000;\n  margin: 0;\n}\n\n.recover-input {\n  width: 100%;\n  max-width: 400px;\n  height: 60px;\n  border-radius: 14px;\n  border: 1px solid rgba(0, 37, 74, 0.3);\n  padding: 0 16px;\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-size: 16px;\n  background: white;\n  color: #00254a;\n  transition: all 0.2s ease;\n}\n\n.recover-input:focus {\n  outline: 2px solid #1c60ea;\n  outline-offset: -1px;\n  border-color: #1c60ea;\n}\n\n.recover-input::placeholder {\n  color: rgba(0, 37, 74, 0.5);\n}\n\n.recover-input:disabled {\n  background: #f4f4f4;\n  cursor: not-allowed;\n}\n\n.recover-field-container.has-error .recover-input {\n  border-color: #e40001;\n  background: linear-gradient(90deg, rgba(228, 0, 1, 0.05) 0%, rgba(228, 0, 1, 0.05) 100%), white;\n}\n\n.recover-error-message {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #e40001;\n  margin: 4px 0 0 0;\n}\n\n.recover-turnstile {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin: 0 0 20px 0;\n}\n\n.recover-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n}\n\n.recover-button-container {\n  display: flex;\n  gap: 16px;\n  width: 100%;\n  flex-direction: column;\n}\n\n@media (min-width: 480px) {\n  .recover-button-container {\n    flex-direction: row;\n  }\n}\n\n.recover-back-button,\n.recover-submit-button {\n  flex: 1;\n  min-height: 48px;\n  padding: 10px 24px;\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 28px;\n  border-radius: 9999px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.recover-back-button {\n  background-color: transparent;\n  color: #00254b;\n  border: 2px solid #00254b;\n}\n\n.recover-back-button:hover:not(:disabled) {\n  background-color: rgba(0, 37, 75, 0.05);\n}\n\n.recover-back-button:active:not(:disabled) {\n  background-color: rgba(0, 37, 75, 0.1);\n}\n\n.recover-submit-button {\n  background-color: #205ea3;\n  color: white;\n}\n\n.recover-submit-button:hover:not(:disabled) {\n  background-color: #174a85;\n}\n\n.recover-submit-button:active:not(:disabled) {\n  background-color: #0f3661;\n}\n\n.recover-submit-button:disabled,\n.recover-back-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.recover-register-link {\n  font-family: 'AvenirNext forINTUIT', sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.6;\n  color: #205ea3;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.2s ease;\n  text-align: center;\n  display: block;\n  width: 100%;\n}\n\n.recover-register-link:hover {\n  color: #1c60ea;\n  text-decoration: underline;\n}\n\n.recover-register-link:focus-visible {\n  outline: 2px solid #1c60ea;\n  outline-offset: 2px;\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
